exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lbaBreadCrumb{background:#f8f8f8;padding:1rem;margin:0 0 1rem}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaBreadCrumb/src/components/lbaBreadCrumb/lbaBreadCrumb.scss"],"names":[],"mappings":"AAAA,eACE,mBACA,aACA,eAAgB,CACjB","file":"lbaBreadCrumb.scss","sourcesContent":[".lbaBreadCrumb {\r\n  background: #f8f8f8;\r\n  padding: 1rem;\r\n  margin: 0 0 1rem;\r\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sass-loader?sourceMap!./src/components/lbaBreadCrumb/lbaBreadCrumb.scss
// module id = 258
// module chunks = 0